import React from 'react';

import { Confirmation, Information } from './common';
import { messageUtility } from '../../utilities/messageUtility';
import {
  isPrimaryCompanyRoleId,
  isPartnerCompanyRoleId,
} from '../../utilities/roleUtility';
import LocalStorageService from '../../services/utilities/LocalStorageService';

export const FieldsExpiredUsageModal = ({
  visible,
  onClose,
  onConfirm,
  onCancel,
}) => {
  const roleId = LocalStorageService.getRoleId();

  if (isPrimaryCompanyRoleId(roleId)) {
    return (
      <Confirmation
        title='Buildee利用終了現場'
        rootClassName='FieldsExpiredUsageModal'
        confirmButtonText='このまま続ける'
        cancelButtonText={messageUtility.getMessage('I-000-008')}
        effectiveButtonClassName='btn'
        visible={visible}
        onClose={onClose}
        onConfirm={onConfirm}
        onCancel={onCancel}
        message={
          <div>
            <div className='description'>
              この現場はBuildee利用終了日を超えています。
              <br />
              以下にご注意ください。
            </div>
            <ul className='detail'>
              <li className='detail__text'>
                元請ユーザーは現場の登録情報を閲覧できますが、
                予定の入力や帳票の出力等をされると現場利用料が発生いたします。
              </li>
              <li className='detail__text'>
                協力会社ユーザーは閲覧、操作できません。
              </li>
              <li className='detail__text'>
                この現場の利用を継続する場合は、現場編集画面からBuildee利用終了日を変更してください。
              </li>
            </ul>
          </div>
        }
      />
    );
  }

  if (isPartnerCompanyRoleId(roleId)) {
    return (
      <Information
        rootClassName='FieldsExpiredUsageModal'
        title='Buildee利用終了現場'
        buttonText={messageUtility.getMessage('I-000-017')}
        visible={visible}
        onClose={onClose}
        message={
          <div className='description'>
            この現場はBuildee利用期間が終了しているため、現在は閲覧、操作することができません。
          </div>
        }
      />
    );
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/components/modals/FieldsExpiredUsageModal.jsx